import { defaultTo } from 'aa_common/front-end/helpers'
import { DATE_FORMAT_RFC, DEPRECIATION_METHOD_CODE } from 'common/constants'
import { convertAttachmentsSubmitPayload, convertPhotosSubmitPayload } from 'common/helpers'
import { AssetLedger, Term } from 'common/models'
import moment from 'moment'

import { SUFFIX_TEMP_CLIENT_FIELD } from './validation'

export const convertSubmitPayload = ({ event_photos, event_attachments, impaired_at, ...rest }: any) => {
  return clearNullValues(
    removeTempFields({
      ...rest,
      impaired_at: moment(impaired_at).format(DATE_FORMAT_RFC),
      event_photos: convertPhotosSubmitPayload(event_photos),
      event_attachments: convertAttachmentsSubmitPayload(event_attachments),
    })
  )
}

const clearNullValues = (data: any) => {
  const newData = { ...data }
  Object.keys(newData).forEach(key => {
    if (newData[key] === null) {
      delete newData[key]
    }
  })
  return newData
}

const removeTempFields = (data: any) => {
  const newData = { ...data }
  Object.keys(newData).forEach(key => {
    if (key.endsWith(SUFFIX_TEMP_CLIENT_FIELD)) {
      delete newData[key]
    }
  })
  return newData
}

export function findPreviousTermMonth(date: string, terms: Term[]) {
  const termMonths =
    (terms || []).find(({ start_date, end_date }) => start_date <= date && date <= end_date)?.term_months || []

  const idx = termMonths.findIndex(({ start_date, end_date }) => {
    return start_date <= date && date <= end_date
  })

  return termMonths[idx - 1] || {}
}

export function isPartialImpairment(ledger?: AssetLedger) {
  const currentDMethod = ledger?.depreciation_method_code
  return (
    currentDMethod &&
    [
      DEPRECIATION_METHOD_CODE.DepreciationMethodAfterImpairmentStraightLine,
      DEPRECIATION_METHOD_CODE.DECLINING_BALANCE_AFTER_IMPAIR,
    ].includes(currentDMethod)
  )
}

export function getUsagePeriodMonthsForImpairment(ledger?: AssetLedger) {
  let serviceLife = 0
  let usagePeriods = 0

  if (isPartialImpairment(ledger)) {
    serviceLife = defaultTo(ledger?.original_service_life, 0)
    usagePeriods = defaultTo(ledger?.original_usage_period_months, 0)
  } else {
    serviceLife = defaultTo(ledger?.service_life, 0)
    usagePeriods = defaultTo(ledger?.usage_period_months, 0)
  }

  if (usagePeriods) return usagePeriods
  if (serviceLife) return serviceLife * 12
  return 1
}
